import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const MaintenanceGuard = ({ children }: { children: React.ReactNode }) => {
  const { profile, maintenanceMode } = useAuth();
  const location = useLocation();

  if (maintenanceMode && (!profile || (profile.role !== 'admin' && profile.role !== 'super_admin'))) {
    if (location.pathname !== '/maintenance') {
      return <Navigate to="/maintenance" replace />;
    }
  }

  // If not in maintenance mode, but they are on the maintenance page, redirect to home
  if (!maintenanceMode && location.pathname === '/maintenance') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
